<template>
  <div class="screenshot-preview">
    <h4>Screenshot Preview</h4>
    
    <div class="preview-container">
      <div class="screenshot-wrapper">
        <img 
          :src="screenshot" 
          alt="Screenshot preview" 
          class="screenshot-image"
          @load="onImageLoad"
        />
        
        <div class="screenshot-overlay">
          <div class="overlay-actions">
            <button @click="$emit('edit')" class="edit-btn">
              <v-icon size="16">mdi-pencil</v-icon>
              Edit & Annotate
            </button>
          </div>
        </div>
      </div>
      
      <div class="preview-actions">
        <button @click="$emit('capture-new')" class="action-btn secondary">
          <v-icon size="16">mdi-camera</v-icon>
          Capture New Screenshot
        </button>
        
        <button @click="$emit('edit')" class="action-btn primary">
          <v-icon size="16">mdi-pencil</v-icon>
          Add Annotations
        </button>
      </div>
    </div>
    
    <div class="preview-info">
      <div class="info-item">
        <v-icon size="16">mdi-monitor</v-icon>
        <span>Full page screenshot captured</span>
      </div>
      <div class="info-item">
        <v-icon size="16">mdi-palette</v-icon>
        <span>Click "Add Annotations" to highlight, draw, or hide sensitive info</span>
      </div>
    </div>
  </div>
</template>

<script>
// Using Material Design Icons that are already available in your project

export default {
  name: 'ScreenshotPreview',
  
  // No need to import icons - using Material Design Icons
  
  props: {
    screenshot: {
      type: String,
      required: true
    }
  },
  
  emits: ['edit', 'capture-new'],
  
  data() {
    return {
      imageLoaded: false
    }
  },
  
  methods: {
    onImageLoad() {
      this.imageLoaded = true
    }
  }
}
</script>

<style scoped>
.screenshot-preview {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  background: #fafafa;
}

.screenshot-preview h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.screenshot-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  background: white;
}

.screenshot-image {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  display: block;
}

.screenshot-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.screenshot-wrapper:hover .screenshot-overlay {
  opacity: 1;
}

.overlay-actions {
  display: flex;
  gap: 12px;
}

.edit-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.edit-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.preview-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  background: white;
}

.action-btn.secondary {
  color: #6b7280;
  border-color: #d1d5db;
}

.action-btn.secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.action-btn.primary {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.action-btn.primary:hover {
  background: #2563eb;
  border-color: #2563eb;
}

.preview-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 13px;
}

.info-item svg {
  color: #9ca3af;
}

@media (max-width: 640px) {
  .preview-actions {
    flex-direction: column;
  }
  
  .action-btn {
    justify-content: center;
  }
  
  .screenshot-image {
    max-height: 200px;
  }
}
</style>